import React from 'react';
import ContinentView from './ContinentView';

import banner from '../assets/centralamerica.jpg';
import costarica from '../assets/costarica.jpg';

const destinations = [
  { name: 'Costa Rica', region: 'costarica', image: costarica }
];

const CentralAmerica = () => (
  <ContinentView
    continentName="Central America"
    bannerImage={banner}
    description="Explore Central America with The Half Time Travel. Discover Costa Rica and lush tropical destinations."
    destinations={destinations}
  />
);

export default CentralAmerica;